export const selectOrderNumber = (isFreeTrial) => {
    if (isFreeTrial) {
        return (state) => { var _a; return (_a = state.freeTrialCart.order.orderDetails.data) === null || _a === void 0 ? void 0 : _a.orderId; };
    }
    return (state) => { var _a; return (_a = state.order.orderDetails.data) === null || _a === void 0 ? void 0 : _a.orderId; };
};
//# sourceMappingURL=selectOrderNumber.js.map